import { useState, useEffect } from 'react';

export const useUrlParams = () => {
  const [params, setParams] = useState(() => {
    const urlParams = new URLSearchParams(window.location.search);
    return {
      hasSelfServeUpsell: urlParams.get('selfServeUpsell') === 'true',
      hasCoupon: urlParams.get('coupon') === 'true' || urlParams.has('coupon'),
      calendarLink: urlParams.get('calendarLink') || urlParams.get('calendar')
    };
  });

  useEffect(() => {
    const handleUrlChange = () => {
      const urlParams = new URLSearchParams(window.location.search);
      setParams({
        hasSelfServeUpsell: urlParams.get('selfServeUpsell') === 'true',
        hasCoupon: urlParams.get('coupon') === 'true' || urlParams.has('coupon'),
        calendarLink: urlParams.get('calendarLink') || urlParams.get('calendar'),
      });
    };

    // Listen for URL changes (useful if iframe URL gets updated)
    window.addEventListener('popstate', handleUrlChange);
    
    return () => {
      window.removeEventListener('popstate', handleUrlChange);
    };
  }, []);

  return params;
};